import { ConfigManager } from '@innolab-trader/config'
import {
  AuthenticationConfig,
  type TradovateStage,
  type TradovateEnvironment,
  type UrlBuilderOptions,
} from '@innolab-trader/tradovate-auth-service'

const stageMap = {
  devel: 'Devel',
  staging: 'Staging',
  uat: 'UAT',
  production: 'Production',
} as const

function resolveStage(): TradovateStage {
  const raw = (ConfigManager.get('stage') || 'devel')
  return stageMap[raw] as TradovateStage
}

/**
 * Get baseApiUrl from ConfigManager or throw if not configured.
 * This ensures all API calls use the correct environment.
 */
export function getBaseApiUrl(): string {
  const baseApiUrl = ConfigManager.get('apiBaseUrl')
  if (!baseApiUrl) {
    throw new Error(
      '[getBaseApiUrl] apiBaseUrl not configured in ConfigManager. ' +
      'Ensure bootstrap.json sets config.apiBaseUrl (e.g., "-d.tradovateapi.com" for devel)'
    )
  }
  return baseApiUrl
}

function resolveUrlBuilderOptions(opts?: Partial<UrlBuilderOptions>): UrlBuilderOptions {
  // Allow caller override via opts, otherwise use ConfigManager
  const baseApiUrl = opts?.baseApiUrl || getBaseApiUrl()
  return { baseApiUrl }
}

export function getAuthConfig(
  env?: TradovateEnvironment,
  opts?: Partial<UrlBuilderOptions>,
): AuthenticationConfig {
  const stage = resolveStage()
  const mergedOpts = resolveUrlBuilderOptions(opts)
  // env is optional; AuthenticationConfig defaults to 'Live' when undefined
  return new AuthenticationConfig(stage, env, 'innolab-trader', (ConfigManager.get('version') as string) || '0.0.0', mergedOpts)
}

export function getEndpoints(
  env?: TradovateEnvironment,
  opts?: UrlBuilderOptions,
) {
  const cfg = getAuthConfig(env, opts)
  return {
    authHttp: cfg.authHttpUrl(),
    primaryHttp: cfg.primaryHttpUrl(),
    primaryWs: cfg.primaryWsUrl(),
    mdWs: cfg.mdWsUrl(),
    reportingHttp: cfg.reportingHttpUrl(),
    storageHttp: cfg.remoteStorageHttpUrl(),
  }
}
